import React, { useCallback } from "react";
import AsyncSelect from "react-select/async";
import debounce from "lodash/debounce";

const AppAsyncSelect = ({ onChange, fetchOptions, placeholder = "Search something...", defaultOptions = true, ...props }) => {
  // Debounce the async fetch function
  const loadOptions = useCallback(
    debounce((inputValue, callback) => {
      fetchOptions(inputValue).then((options) => {
        callback(options);
      });
    }, 800),
    []
  );

  return (
    <div style={{ width: 300 }}>
      <AsyncSelect
        cacheOptions
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        placeholder={placeholder}
        onChange={onChange}
        isClearable
        {...props}
      />
    </div>
  );
};

export default AppAsyncSelect;
